import React from 'react';
import {
    Modal,
    Drawer,
    Button,
    List,
    Empty,
    Typography,
    Divider
} from 'antd';
import { StaffListItem } from "./StaffListItem";
import { ObjectListItem } from "./ObjectListItem";

const { Text } = Typography;

export const ModalsAndDrawers = ({
                                     addStaffModalVisible,
                                     setAddStaffModalVisible,
                                     addObjectsModalVisible,
                                     setAddObjectsModalVisible,
                                     currentTeamIndex,
                                     selectedStaff,
                                     setSelectedStaff,
                                     selectedObjects,
                                     setSelectedObjects,
                                     getAvailableStaff,
                                     getAvailableObjects,
                                     addStaffToTeam,
                                     addObjectToTeam,
                                     isMobile
                                 }) => {

    const handleStaffSelection = (staffId, checked) => {
        if (checked) {
            setSelectedStaff(prev => [...prev, staffId]);
        } else {
            setSelectedStaff(prev => prev.filter(id => id !== staffId));
        }
    };

    const handleObjectSelection = (objectId, checked) => {
        if (checked) {
            setSelectedObjects(prev => [...prev, objectId]);
        } else {
            setSelectedObjects(prev => prev.filter(id => id !== objectId));
        }
    };

    const handleAddStaff = () => {
        const availableStaff = getAvailableStaff();
        const selectedStaffItems = availableStaff.filter(person =>
            selectedStaff.includes(person.id)
        );
        addStaffToTeam(currentTeamIndex, selectedStaffItems);
        setAddStaffModalVisible(false);
        setSelectedStaff([]);
    };

    const handleAddObjects = () => {
        const availableObjects = getAvailableObjects(currentTeamIndex);
        const selectedObjectItems = availableObjects.filter(obj =>
            selectedObjects.includes(obj.id)
        );
        addObjectToTeam(currentTeamIndex, selectedObjectItems);
        setAddObjectsModalVisible(false);
        setSelectedObjects([]);
    };

    // Получаем актуальные данные для отображения
    const availableStaff = getAvailableStaff();
    const availableObjects = getAvailableObjects(currentTeamIndex);

    // Группируем объекты по районам для модального окна
    const groupedObjects = availableObjects.reduce((acc, obj) => {
        const district = obj.district || 'Без района';
        if (!acc[district]) {
            acc[district] = [];
        }
        acc[district].push(obj);
        return acc;
    }, {});

    // Сортируем районы по алфавиту
    const sortedDistricts = Object.keys(groupedObjects).sort();

    // Функция для рендеринга сгруппированных объектов
    const renderGroupedObjects = () => {
        if (availableObjects.length === 0) {
            return <Empty description="Все объекты распределены"/>;
        }

        return (
            <div style={{ maxHeight: '60vh', overflow: 'auto' }}>
                {sortedDistricts.map(district => (
                    <div key={district}>
                        <Divider orientation="left" orientationMargin="0">
                            <Text strong style={{ fontSize: '14px' }}>
                                {district}
                                <Text type="secondary" style={{ fontSize: '12px', marginLeft: 8 }}>
                                    ({groupedObjects[district].length} объектов)
                                </Text>
                            </Text>
                        </Divider>
                        <List
                            dataSource={groupedObjects[district]}
                            renderItem={(obj) => (
                                <ObjectListItem
                                    obj={obj}
                                    selectedObjects={selectedObjects}
                                    handleObjectSelection={handleObjectSelection}
                                />
                            )}
                        />
                    </div>
                ))}
            </div>
        );
    };

    // Для мобильных устройств используем Drawer'ы
    if (isMobile) {
        return (
            <>
                <Drawer
                    title="Добавить сотрудников"
                    placement="bottom"
                    height="70%"
                    open={addStaffModalVisible}
                    onClose={() => {
                        setAddStaffModalVisible(false);
                        setSelectedStaff([]);
                    }}
                    extra={
                        <Button
                            type="primary"
                            onClick={handleAddStaff}
                            disabled={selectedStaff.length === 0}
                        >
                            Добавить ({selectedStaff.length})
                        </Button>
                    }
                >
                    <List
                        dataSource={availableStaff}
                        renderItem={(person) => (
                            <StaffListItem
                                person={person}
                                selectedStaff={selectedStaff}
                                handleStaffSelection={handleStaffSelection}
                            />
                        )}
                        locale={{
                            emptyText: <Empty description="Все сотрудники распределены"/>
                        }}
                    />
                </Drawer>

                <Drawer
                    title="Добавить объекты"
                    placement="bottom"
                    height="80%"
                    open={addObjectsModalVisible}
                    onClose={() => {
                        setAddObjectsModalVisible(false);
                        setSelectedObjects([]);
                    }}
                    extra={
                        <Button
                            type="primary"
                            onClick={handleAddObjects}
                            disabled={selectedObjects.length === 0}
                        >
                            Добавить ({selectedObjects.length})
                        </Button>
                    }
                >
                    {renderGroupedObjects()}
                </Drawer>
            </>
        );
    }

    // Для десктопов используем модальные окна
    return (
        <>
            <Modal
                title="Добавить сотрудников в команду"
                open={addStaffModalVisible}
                onCancel={() => {
                    setAddStaffModalVisible(false);
                    setSelectedStaff([]);
                }}
                onOk={handleAddStaff}
                okText={`Добавить выбранных (${selectedStaff.length})`}
                cancelText="Отмена"
                width={600}
                okButtonProps={{ disabled: selectedStaff.length === 0 }}
            >
                <List
                    dataSource={availableStaff}
                    renderItem={(person) => (
                        <StaffListItem
                            person={person}
                            selectedStaff={selectedStaff}
                            handleStaffSelection={handleStaffSelection}
                        />
                    )}
                    locale={{
                        emptyText: <Empty description="Все сотрудники распределены"/>
                    }}
                />
            </Modal>

            <Modal
                title="Добавить объекты в команду"
                open={addObjectsModalVisible}
                onCancel={() => {
                    setAddObjectsModalVisible(false);
                    setSelectedObjects([]);
                }}
                onOk={handleAddObjects}
                okText={`Добавить выбранные (${selectedObjects.length})`}
                cancelText="Отмена"
                width={800}
                okButtonProps={{ disabled: selectedObjects.length === 0 }}
            >
                {renderGroupedObjects()}
            </Modal>
        </>
    );
};